import { tableHeaderStyle } from './simple-export'

function createFilterRow(filter, columnCount, defaultFilterValue) {
  return [
    {
      value: `${filter?.title}: ${filter?.data ?? defaultFilterValue}`,
      columnSpan: columnCount
    },
    ...Array(columnCount - 1).fill(null)
  ]
}

function createHeaderRows(columns) {
  const hasSubLabels = columns.some((column) => column.subLabels)
  const firstRow = []
  const secondRow = hasSubLabels ? Array(columns.length).fill(null) : null

  columns.forEach((column, index) => {
    if (!column.label) {
      firstRow[index] = null
      return
    }

    if (column.subLabels) {
      firstRow[index] = {
        value: column.label,
        columnSpan: column.subLabels.length,
        ...tableHeaderStyle
      }
      column.subLabels.forEach((subLabel, offset) => {
        secondRow[index + offset] = {
          value: subLabel,
          ...tableHeaderStyle
        }
      })
      return
    }

    firstRow[index] = {
      value: column.label,
      ...(hasSubLabels ? { rowSpan: 2 } : {}),
      ...tableHeaderStyle
    }
  })

  return hasSubLabels ? [firstRow, secondRow] : [firstRow]
}

export function buildFilteredTableReportSheet({
  filterEx = [],
  data = [],
  columns,
  sheetName = 'Sheet1',
  defaultFilterValue = 'พนักงาน',
  textColumnKeys = []
}) {
  const textColumnKeySet = new Set(textColumnKeys)

  return {
    sheetData: [
      ...filterEx.map((filter) =>
        createFilterRow(filter, columns.length, defaultFilterValue)
      ),
      ...createHeaderRows(columns),
      ...data.map((row) =>
        columns.map((column) => {
          const value = row[column.key] ?? ''

          return {
            value: textColumnKeySet.has(column.key) ? String(value) : value
          }
        })
      )
    ],
    sheetOptions: {
      sheet: sheetName
    }
  }
}
